import { useState, useEffect } from 'react';

const selectStyle = {
    width: '100%',
    padding: '9px 12px',
    fontSize: '13px',
    fontWeight: 500,
    border: '1.5px solid var(--border-color)',
    borderRadius: '8px',
    outline: 'none',
    background: 'var(--input-bg)',
    color: 'var(--text-color)',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    paddingRight: '32px',
};

const getAppRank = (app) => {
    const rank = Number(app?.rank);
    return Number.isFinite(rank) ? rank : Number.MAX_SAFE_INTEGER;
};

const sortAppsByRank = (items) => {
    if (!Array.isArray(items)) return [];

    return [...items].sort((a, b) => {
        const rankDiff = getAppRank(a) - getAppRank(b);
        if (rankDiff !== 0) return rankDiff;

        return (a.label || a.code || '').localeCompare(
            b.label || b.code || '',
            'fr',
            { sensitivity: 'base' }
        );
    });
};

const AppCombo = ({ onChange, defaultValue, ...props }) => {
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const data = localStorage.getItem('allowed_apps');
        if (data) {
            const appArray = JSON.parse(data);
            setApps(sortAppsByRank(appArray));
            setLoading(false);
        } else {
            setError('Erreur lors de la récupération des applications');
        }
    }, []);

    if (loading) return <div style={{ padding: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>Chargement...</div>;
    if (error) return <div style={{ padding: '8px', fontSize: '13px', color: '#ef4444' }}>{error}</div>;

    return (
        <select
            onChange={onChange}
            defaultValue={defaultValue}
            style={selectStyle}
            onFocus={(e) => {
                e.target.style.borderColor = 'var(--input-focus)';
                e.target.style.boxShadow = '0 0 0 3px var(--accent-light)';
            }}
            onBlur={(e) => {
                e.target.style.borderColor = 'var(--border-color)';
                e.target.style.boxShadow = 'none';
            }}
            {...props}
        >
            <option value="">Sélectionner une app…</option>
            {apps.map(app => (
                <option key={app.id} value={app.id}>
                    {app.label}
                </option>
            ))}
        </select>
    );
};

export default AppCombo;
